
const { ccclass, property } = cc._decorator;
import Utility from "../../../../utility/utility";
import TableMenu from "../../../public/ui/table_menu";
import BiPaiTableSeatView from "./bipai_table_seat_view";
import BiPaiTableBaseView from "./bipai_table_base_view";
import BiPaiMySeatCards from "./bipai_myseat_cards";
import LanguageManager from "../../../../manager/language_manager";
import MatchWaitStartView from "../../../public/module/match_wait_start/match_wait_start_view";
import AppData from "../../../public/const/app_data";
import GapProgressBar from "../../../../uiextend/gap_progress_bar";

@ccclass
export default class BiPaiTableView extends BiPaiTableBaseView {

    
    @property(cc.Button)
    buttonSetting: cc.Button = null

    @property(TableMenu)
    tableMenu: TableMenu = null

    isMatchingView: boolean = false

    @property(cc.Animation)
    animationBtns: cc.Animation = null

    @property(cc.Animation)
    animationDiscardBtns: cc.Animation = null

    @property(cc.Button)    
    buttonOpenCard: cc.Button = null

    @property(cc.Node)
    nodeProgressBarWin: cc.Node = null

    @property([GapProgressBar])
    gapProgressBarWinRateList: GapProgressBar[] = []

    @property(cc.Label)
    labelWinRate: cc.Label = null

    @property(cc.Button)
    buttonMoreCard: cc.Button = null

    @property(cc.Button)
    buttonSystemOpenBtn: cc.Button = null

    @property(cc.Button)
    buttonFollow: cc.Button = null

    @property(cc.Button)
    buttonDiscard: cc.Button = null


    @property(BiPaiMySeatCards)
    mySeatCards: BiPaiMySeatCards = null

    @property(cc.Node)
    nodeMoreBtn: cc.Node = null

    @property(cc.Node)
    nodeBtnRoot: cc.Node = null

    @property(cc.Label)
    labelRecordLabel: cc.Label = null

    @property(cc.Node)
    nodeFollowMultiple: cc.Node = null

    @property(cc.Label)
    labelFollowMultiple: cc.Label = null

    @property(cc.Node)
    nodeFollowMultipleChangeAnim1: cc.Node = null

    @property(cc.Animation)
    animFollowMultiple: cc.Animation = null

    @property(MatchWaitStartView)
    matchWaitStartView: MatchWaitStartView = null

    onLoad(){
        super.onLoad()
    }

    resetView(){
        if(this.isMatchingView){
            return
        }
        super.resetView()
        
        this.showSettingBtn(false)      
        this.showOpenCardBtn(false)
        this.showMoreCardBtn(false)
        this.showSystemOpenBtn(false)
        this.showFollowBtn(false)
        this.showDiscardBtn(false)
        this.showMoreBtn(true)
        this.showRecordLabel(false)
    }

    resetSeatAll(i: number){
        super.resetSeatAll(i)
        this.showSeatIntrustedTag(i, false)
    }

    protected _setBtnGrayAndDisable(btn: cc.Button, gray: boolean){
        Utility.setNodeGray(btn.node, gray)
        btn.enabled = !gray
    }

    showSettingBtn(show: boolean){
        this.buttonSetting.node.active = show || false
    }

    

    showSeatIntrustedTag(localPos: number, show: boolean){
        let seatView = this.getSeatViewByPos<BiPaiTableSeatView>(localPos)
        seatView.showIntrustedTag(show)
    }

    showOpenCardBtn(show: boolean, disable?: boolean){
        this.buttonOpenCard.node.active = !!show
        this.buttonOpenCard.enabled = !disable   
    }

    showMoreCardBtn(show: boolean, disable?: boolean){
        this.buttonMoreCard.node.active = !!show
        this.buttonMoreCard.enabled = !disable
    }

    showSystemOpenBtn(show: boolean, disable?: boolean){
        this.buttonSystemOpenBtn.node.active = !!show
        this.buttonSystemOpenBtn.enabled = !disable
    }
    

    showFollowBtn(show: boolean, isGray?: boolean, disable?: boolean){
        this.buttonFollow.node.active = !!show
        this.buttonFollow.enabled = !disable
        // Utility.setNodeGray(this.buttonFollow.node, !!isGray)
    }

    showDiscardBtn(show: boolean, isGray?: boolean, disable?: boolean){
        this.buttonDiscard.node.active = !!show
        this.buttonDiscard.enabled = !disable
        // Utility.setNodeGray(this.buttonDiscard.node, !!isGray)
    }

    showMoreBtn(show: boolean){
        this.nodeMoreBtn.active = !!show
    }

    playBtnsFadeAnim(show: boolean, onFinish?: Function){
        let self = this
        // let node = self.nodeBtnRoot
        // let fadeFrom = show? 0: 255
        // let fadeTo = show? 255: 0
        // let fromScale = show? 0.7: 1
        // let toScale = show? 1: 0.7
        // let duration = 0.3
        // self.playFadeAnim(node, fadeFrom, fadeTo, duration, 0)
        // node.scale = fromScale
        // self.playNodeAnim(node, node.position, toScale, 0, duration, 0, onFinish, cc.easeBackOut())        
        self.playBtnsAnim(self.animationBtns, show, onFinish)
    }

    playDiscardBtnAnim(show: boolean, onFinish?: Function){
        this.playBtnsAnim(this.animationDiscardBtns, show, onFinish)
    }

    protected playBtnsAnim(anim: cc.Animation, show: boolean, onFinish?: Function){
        let clipName = show? 'anim_anniutanchu': 'anim_anniuxiaoshi'
        anim.unscheduleAllCallbacks()
        anim.play(clipName)
        let duration = show? 0.23: 0.12
        anim.scheduleOnce(function(){
            onFinish && onFinish()
        }, duration)
    }

    playBtnClickAnim(node: cc.Node){
        let anim = node.getComponent(cc.Animation)
        if(anim){
            anim.play()
        }
    }

    showRecordLabel(show: boolean, recordNo?: string){
        this.labelRecordLabel.node.active = !!show
        if(show){
            this.labelRecordLabel.string = LanguageManager.t("record_number", true) + ':' + recordNo
        }
    }

    showFollowMultiple(show: boolean, multiple?: number){
        this.nodeFollowMultiple.active = !!show
        if(show){
            this.labelFollowMultiple.string = multiple.toString()
        }
    }

    playFollowMultipleChangeAnim(startChangeCallback: Function, onFinish?: Function){
        let self = this        
        self.nodeFollowMultipleChangeAnim1.active = true        
        self.scheduleOnce(function(){
            self.nodeFollowMultipleChangeAnim1.active = false
            onFinish && onFinish()
        }, 0.8)
        self.scheduleOnce(function(){
            startChangeCallback && startChangeCallback()
            self.animFollowMultiple.play()
        }, 0.45)
    }

    showMatchPanel(show: boolean, state?: number, leftSecs?: number){
        this.matchWaitStartView.showPanel(show, state, leftSecs)
    }

    refreshOpenCardSuccessProgress(show: boolean, rate?: number){
        this.nodeProgressBarWin.active = !!show
        if(!show){
            return
        }
        let showIndex = 0
        rate = rate || 0
        if(rate > 0.65){
            showIndex = 2
        }else if(rate > 0.4){
            showIndex = 1
        }else{
            showIndex = 0
        }
        for (let index = 0; index < this.gapProgressBarWinRateList.length; index++) {
            const element = this.gapProgressBarWinRateList[index];
            element.node.active = index == showIndex
            if(index == showIndex){
                element.progress = rate
            }
        }
        this.labelWinRate.node.active = !!AppData.testMode
        this.labelWinRate.string = (rate * 100).toFixed(0) + '%'
    }
}
